// extracted by mini-css-extract-plugin
export default {"input-textarea":"input-textarea--957f3b","inputTextarea":"input-textarea--957f3b"};